import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-6d298fc3.js';
import React from 'react';
import 'crypto';
import AdaptiveImage, { initImages } from 'react-adaptive-image';
initImages({
  imageResolver: function imageResolver(image) {
    var imageServerURL = "https://sharp.accropress.com";
    return "".concat(imageServerURL).concat(removeCDNFromLink(image.fileName), "?").concat(generateSharpQueryEndings({
      w: image.width
    }, removeCDNFromLink(image.fileName)));
  }
});

var returnResizedImageURL = function returnResizedImageURL(settings, imagePath) {
  if (imagePath && imagePath.includes("https://cdn2.accropress.com")) {
    var imageServerURL = "https://sharp.accropress.com";
    return "".concat(imageServerURL).concat(removeCDNFromLink(imagePath), "?").concat(generateSharpQueryEndings(settings, removeCDNFromLink(imagePath)));
  } else {
    return imagePath;
  }
};

var getAdaptiveImage = function getAdaptiveImage(filename, isBackgroundImage, className, altText, width, height, quality, auto, crop, focalcrop) {
  return /*#__PURE__*/React.createElement(AdaptiveImage, {
    fileName: filename,
    width: width,
    height: height,
    quality: quality,
    auto: auto,
    crop: crop,
    focalcrop: focalcrop,
    className: className,
    altText: altText,
    backgroundImage: isBackgroundImage || false
  });
};

var removeCDNFromLink = function removeCDNFromLink(link) {
  return link.replace("https://cdn2.accropress.com", "");
};

var generateSharpQueryEndings = function generateSharpQueryEndings(settings, path) {
  // auto=compress=format
  // crop=focalpoint
  // fit=crop
  // fp-x=0.5
  // fp-y=0.5
  // h=460&q=80
  // w=700
  var querystring = Object.keys(settings).map(function (key) {
    return key + "=" + settings[key];
  }).join("&");
  return querystring + "&s=" + generateSecretLink(path, "?" + querystring);
};

var buildQueryStringFromObject = function buildQueryStringFromObject(querystringParameters) {
  var string = "";

  for (var _i = 0, _Object$entries = Object.entries(querystringParameters); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        k = _Object$entries$_i[0],
        v = _Object$entries$_i[1]; // Don't hash the security token


    if (k !== "s") {
      string += "&" + k + "=" + encodeURIComponent(v);
    }
  }

  if (string.substr(1) === "") {
    return "";
  }

  return string.substr(1);
};

var fixedEncodeURIComponent = function fixedEncodeURIComponent(str) {
  return str.replace(/([^\w\-\/\:@])/gi, function (match) {
    return encodeURIComponent(match).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A");
  });
};

var calculateHash = function calculateHash(path, querystringParameters, securityKey) {
  var crypto = require("crypto"); // Get the full query (minus the hash parameter)


  var query = querystringParameters; // Encode each part of the URI. (Note, we're not using URLEncode on the entire thing, as it doesn't
  // properly handle "+" signs

  var encodedPath = fixedEncodeURIComponent(decodeURIComponent(path));
  var source = securityKey + encodedPath + query;
  var parsed = crypto.createHash("md5").update(source).digest("hex");
  return parsed;
};

var generateSecretLink = function generateSecretLink(imagePath, imageQuery) {
  return calculateHash(imagePath, imageQuery, process.env.IMAGE_FORMATTING_SECRET || process.env.GATSBY_IMAGE_FORMATTING_SECRET);
};

export { buildQueryStringFromObject, calculateHash, fixedEncodeURIComponent, generateSecretLink, generateSharpQueryEndings, getAdaptiveImage, removeCDNFromLink, returnResizedImageURL };